var _use, _use2, _image, _image2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDecoration1O(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 1280 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 546,
    height: 13,
    x: 734.501
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1495 1496h39.924v40H1495z",
    style: {
      fill: "url(#b)"
    },
    transform: "matrix(0 .30057 -13.6989 0 21773.6 -448.858)"
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 546,
    height: 13
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1495 1496h39.924v40H1495z",
    style: {
      fill: "url(#d)"
    },
    transform: "matrix(0 .30057 13.6989 0 -20493.6 -448.858)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -40 4238.55 0 1514.96 1536)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "white",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(0 -40 4238.55 0 1514.96 1536)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "white",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAiIAAAANCAYAAACU0QXgAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACnElEQVR4nO1dy2oDMQycLS30K/qv/d2mp5wSAk0vaQnGa0uybClhBkrwSqPxjh9rwpJu+Pjc0EYtruX08q05Mzge97uS08vJwqFH9CiKQ4/oURQnSz8yci4AjgC+XgXFJBNU09lWXUlcU8OiE6Vr0dFsHtG+SnIy+9rLiZ7zozpZfS3j0pwIXS8dLSd6bGqxbL569t1bd8acl+RE398ZwAEAagcRyUbrsRH0dLwXplSndZ+ah5AHd7U3vb5ZvBnheoynl87IeK7U78W8dGavk14tic4j7SEjXC9vRrjaPSTTOpG2LTpe42nV9+aU8VpbonMFcLp9HlrfiGgQZcrshTlj0s3QtXBGJrtFx2PzWqW7+iHk4ZGl/qy+ztS1cqS5q/raqyGpH+XRCNdDL2rP1OSu7mutHd3XVu711n4H8OZ1ECGeA1kXFTeefn809enRXF0PjyycKI8snCiPrBxpbhaPLPVXevRz+9wA4KVShCAIgiAIYgl4ECEIgiAIIgw8iBAEQRAEEQYeRAiCIAiCCANfViXucS3a2871Vqx3XcKJ0m1xtLoWTpRHFk6URxpOtEeaPj2SRzWU9aTXazFpbYuulROh+8we3f+5HUSki6wVG+FkmUCtiVO+SdzSG3mbes8DDXevb5a3qke4Xm+Pe+iMvEW+Ur8X89IZGc/WtSzejMy5qHWiyV09T6P1R+beiI7XeFr1vTllvNaW6Pz9jsgJwKV2ENGcuvdyynbrAb2nZxmMmoZ2w4nStehIFtcM3Vk6mX3t5UTpeulk9bWMS3MidL10tJzosanFsvnq2Xdv3RlzXpITfX9nAN8Ajq1vRCRfx+3ltszZq9u6IUldL45mk87A6eVk4dAjehTFoUf0KIqTpR8ZOf//a+YXk7Jywwmk9B4AAAAASUVORK5CYII=",
    id: "a",
    width: 546,
    height: 13
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAiIAAAANCAYAAACU0QXgAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACtUlEQVR4nO1dy2obQRAsiYXYBAzBl1zsz/D/+VtzyS0HQ4wvVg6RwF5m1I/p2W5ZVWDM7HZ19dTOS2aRd3h8fgJwD+AGwA5tHIS2FF+ZI8V7Y2ZwLslXTUwVDj2iR1kcekSPsjhV6sAC4AHAI4DvAPZC4l5C6b4lRyvG2o7S1eaw6Fgm1WzdiJjKvkox2b6OelTVV0+OGbqamCgdK6fKs/FyqvQvSzfCo0hdTYwnx/qPE5Z1SB23APgB4CeAO3w+iGgOBhELu2ahjeCs77fann6OeCPFRHoTvenNfDae/o7W5uVqxsJM/VGOpz1zLGR7M7KReHRmzROtvrU2bd5q89RSm2dOW7gR83SWNyfsVtcPnesfr/Vytu5/0lsAfDv+3MJ+EFm3oxfJrQf5FoP7q3s0otdqz1xYsxb0CH89+S/RIy9HG7tVrVIOTf4qHnk4rVqlT9tZa+aucU+Kben17knXe/mkHJKv5/y2ciy1iliOv/fHxPtO0nNma+OsD8XLydK1emTJn+3RaH7toO7FWXJEc7J0pXos+enRNrqammZtBlbOiK6HI34qJq4XvXdCCIIgCIIgpoMHEYIgCIIg0sCDCEEQBEEQaeBBhCAIgiCINJxeVn3H/xeH3j/cy3oT3MPJ0rXUdC0ejei12p7+WTnnas3SnfH8LtEjL0cbu1WtUg5N/ioeeTjnaiWuHAuAt+PPK/g9IlkLgDWXRsezEERuOiPPZusNeoQbtQl59Uc5nvbMsZDtjWWeaDhZ80Srb61Nm7faPLXU5pnTFm7EPK00T4axAPgD4DeAF/CbVbfon2awbaUbEVPZVykm29dRj6r66skxQ1cTE6Vj5VR5Nl5Olf5l6UZ4FKmriZk9bqR2V3cB8AvAX/B/zVh1ZuSt6pGXI8VU4dAjepTFoUf0KItTpQ78A4+oGsf7bvRRAAAAAElFTkSuQmCC",
    id: "c",
    width: 546,
    height: 13
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoration1O);
export default __webpack_public_path__ + "static/media/decoration1-o.e19f9e57813efd3f4d0f476a6d2be1d1.svg";
export { ForwardRef as ReactComponent };